import isString from 'transmute/isString';
import { STATIC, isRollingDatePointType } from '../../types/operator/RollingDatePointType';
import { DateStaticOrDynamicDisplayType } from '../DisplayTypes';
import { DateStaticOrDynamicInputType } from '../InputTypes';
import { makeOperator } from './Operator';
import { validateRollingDatePointConfig } from '../rollingDates/RollingDatePointConfig';
export const name = 'BeforeDateStaticOrDynamic';

// value should correspond to Less<String>'s value when type is STATIC, BeforeRollingDatePoint's value when type is DYNAMIC
export default makeOperator({
  displayType: DateStaticOrDynamicDisplayType,
  inputType: DateStaticOrDynamicInputType,
  name,
  values: [{
    name: 'value',
    isValid: value => !!value && (isString(value) || validateRollingDatePointConfig(value))
  }, {
    name: 'type',
    defaultValue: STATIC,
    isValid: isRollingDatePointType
  }]
});